<template>
  <div class="update-item-list">
    <q-card class="my-card">
      <q-card-section class="card-section">
        <div class="card-title">{{ module.Name }}</div>
      </q-card-section>
      <q-separator />
        <q-card-section class="card-content">
          <q-file
            square
            outlined
            dark
            v-model="itemList"
            label="Pick Item List (Item List must be readable)"
            @blur="v$.itemList.$touch()"
            :error="v$.itemList.$error"
            @update:model-value="handleUpload()"
            error-message="Item List is Required"
          />
        <q-btn class="update-item-list-btn" label="Submit" @click="submit"/>
      </q-card-section>
    </q-card>
  </div>
</template>
  <script>
  import { mapActions } from 'vuex';
  import { required } from "vuelidate/lib/validators";
  import { useVuelidate } from '@vuelidate/core'
  
  export default {
    name: 'UpdateItemList',
    props: {
      module: {
        require: true,
        type: Object
      }
    },
    setup () {
      return { v$: useVuelidate() }
    },
    validations () {
      return {
        itemList: {
          required
        }
      }
    },
    data () {
      return {
        itemList: null,
        itemListB64: null,
        itemListUrl: null
      }
    },
    methods: {
      ...mapActions({
        requestUpdateItemList: 'itemShop/requestUpdateItemList'
      }),
      async handleUpload () {
        if (this.itemList) {
          this.itemListUrl = URL.createObjectURL(this.itemList);
        }

        await this.createBase64(this.itemList)
      },
      async submit () {
        this.v$.$touch();

        if (this.v$.$invalid) {
          return
        }

        this.$q.loading.show();
        
        await this.recaptchaLoad('updateItemList')

        const param = {
          itemList: this.itemListB64
        }
  
        await this.requestUpdateItemList(param)
          .then(async response => {
            this.resetFields()
            await this.recaptchaLoad('updateItemList')

            this.$q.notify({
              position: 'top-right',
              message: response.data.message,
              type: 'positive'
            })
  
            this.$q.loading.hide()
          })
          .catch((error) => {
            this.$q.notify({
              position: 'top-right',
              message: error.response.data.message,
              type: 'negative'
            })
  
            this.$q.loading.hide();
          })
      },
      createBase64: function(FileObject) {
        const reader = new FileReader();

        reader.onload = (event) => {
          this.itemListB64 = event.target.result;
        }

        reader.readAsDataURL(FileObject);
      },
      resetFields() {
        this.v$.$reset()

        this.itemListUrl = null
        this.itemList = null
        this.itemListB64 = null
      }
  }
}
</script>
<style lang="scss">
.update-item-list {
  .my-card {
    background-color: $backgroundHeader;

    .card-title {
      font-size: 16px;
      font-weight: 700;
    }

    .card-section {
      color: white;
    }

    .card-content {
      background-color: $background;
      display: grid;
      grid-template-rows: 1fr 1fr;
      gap: 16px;
    }

    .q-input {
      color: white;
    }

    .q-field__control:before {
      border-color: white;
    }
    
    .update-item-list-btn {
      background-color: #FFC108;
    }
  }

  .my-card-edit {
    background-color: $backgroundHeader;
    margin-top: 16px;

    .card-title {
      font-size: 16px;
      font-weight: 700;
    }
    
    .card-section {
      color: white;
    }

    .card-content {
      background-color: $background;
      display: flex;
      grid-template-rows: 1fr 1fr;
      gap: 16px;
    }
  }

  .q-layout__section--marginal {
    background-color: $background;
  }
}
</style>